import { ErrorMessage, Field } from 'formik';
import React, { memo } from 'react';
import FormField from '../FormField/FormField';
import { FormFieldBlokProps } from '../FormFieldBlokProps.interface';
import { FormFieldSelectOptionBlokProps } from '../FormFieldSelectOptionBlokProps.interface';
import classNames from 'classnames';

interface FormFieldSingleOptionSelectButtonsBlokProps
  extends FormFieldBlokProps {
  options: FormFieldSelectOptionBlokProps[];
  preselected_option: FormFieldSelectOptionBlokProps[];
}

interface FormFieldSingleOptionSelectButtonsProps {
  blok: FormFieldSingleOptionSelectButtonsBlokProps;
}

const FormFieldSingleOptionSelectButtons: React.FC<
  FormFieldSingleOptionSelectButtonsProps
> = ({ blok }) => {
  const {
    label,
    description = undefined,
    is_required,
    error_message = undefined,
    tool_tip = [],
    tool_tip_label,
    key,
    options,
    preselected_option,
  } = blok;

  return (
    <FormField
      label={label}
      description={description}
      errorMessage={error_message}
      toolTip={tool_tip}
      toolTipLabel={tool_tip_label}
      key={key}
    >
      <Field id={key} name={key}>
        {({ field }: any) => {
          const items = options.map(
            (option: FormFieldSelectOptionBlokProps) => {
              const isChecked = field.value === option.value;
              return (
                <React.Fragment key={option.value}>
                  <input
                    {...field}
                    type="radio"
                    id={key + option.value}
                    value={option.value}
                    checked={isChecked}
                    className="hidden"
                  />

                  <label
                    htmlFor={key + option.value}
                    className={classNames(
                      'cursor-pointer flex items-center justify-center h-12 px-4 py-3 gap-x-3.5 border rounded-default',
                      {
                        'bg-system/white border-border/default text-text/body-tint':
                          !isChecked,
                        'bg-button/primary-bg border-button/primary-bg text-system/white':
                          isChecked,
                      }
                    )}
                  >
                    <p className="font-bold">{option.description}</p>
                    <div
                      className={classNames(
                        'w-5 h-5 rounded-full border-2 flex items-center justify-center',
                        {
                          'border-text/body-tint': !isChecked,
                          'border-system/white': isChecked,
                        }
                      )}
                    >
                      <div
                        className={classNames(
                          'w-3 h-3 rounded-full bg-system/white',
                          {
                            invisible: !isChecked,
                            visible: isChecked,
                          }
                        )}
                      />
                    </div>
                  </label>
                </React.Fragment>
              );
            }
          );

          return (
            <ul className="pt-2 flex items-center justify-start gap-x-4">
              {items}
            </ul>
          );
        }}
      </Field>
      <ErrorMessage
        name={key}
        render={(msg) => <div className="text-text/body-primary">{msg}</div>}
      />
    </FormField>
  );
};

export default memo(FormFieldSingleOptionSelectButtons);
